import { sets } from 'abis/set/sets'
import { AnalyticsArea, useAnalyticsEventTracker } from 'hooks'
import moment from 'moment'
import type React from 'react'
import { TransactionStatus } from 'sdk/omni/omni-transaction-service/types'
import type { Transaction } from 'services'
import { useAccount } from 'wagmi'
import { extractTransactionDetails, getIcon, textSwitch } from '../controller'
import {
  AssetIconWrapper,
  ItemWrapper,
  StyledLeftColumn,
  StyledListWrapper,
  StyledRightColumn,
  StyledTXFailedText,
  StyledTXText,
  TextAndSubText,
} from '../style'
import EmptyTransactionsList from './empty-list'

type TransactionItemProps = {
  transaction: Transaction
  showTimeStamp?: boolean
  pastTense: boolean
}

const TransactionItem: React.FC<TransactionItemProps> = ({
  transaction,
  showTimeStamp,
  pastTense,
}) => {
  const { navigationEvent } = useAnalyticsEventTracker(AnalyticsArea.WalletManagement)
  const txDetails = extractTransactionDetails(transaction)
  const icon = getIcon(txDetails)
  const exploreTransaction = () => {
    const hash = transaction.replacementHash ? transaction.replacementHash : transaction.hash
    return navigationEvent(`${sets[transaction.action.network].blockExplorer}/tx/${hash}`, true)
  }
  return (
    <ItemWrapper onClick={exploreTransaction}>
      <StyledLeftColumn>
        <AssetIconWrapper src={icon} />
        <TextAndSubText>
          <StyledTXText>{textSwitch(txDetails, pastTense)}</StyledTXText>
          {transaction.status === TransactionStatus.FAILED && (
            <StyledTXFailedText>Transaction failed. </StyledTXFailedText>
          )}
          {transaction.isUserContract && transaction.isRejected && (
            <StyledTXFailedText>Transaction rejected or replaced. </StyledTXFailedText>
          )}
        </TextAndSubText>
      </StyledLeftColumn>
      <StyledRightColumn>
        {showTimeStamp && moment(transaction.addedTime).format('DD MMM, HH:mm:ss')}
      </StyledRightColumn>
    </ItemWrapper>
  )
}

type TransactionListProps = {
  transactions: Transaction[]
  pastTense: boolean
  showTimeStamp?: boolean
}
/**
 * Container for Showing a TX list
 */
const TransactionList: React.FC<TransactionListProps> = ({
  transactions,
  pastTense,
  showTimeStamp,
}) => {
  const { address } = useAccount()

  const filteredTransactions = transactions.filter((item) => address && item.account === address)

  if (filteredTransactions.length === 0) {
    return <EmptyTransactionsList />
  }

  const byDate = (a: Transaction, b: Transaction) => b.addedTime - a.addedTime

  return (
    <StyledListWrapper>
      {filteredTransactions.sort(byDate).map((tx) => (
        <TransactionItem
          key={tx.hash}
          transaction={tx}
          showTimeStamp={showTimeStamp}
          pastTense={pastTense}
        />
      ))}
    </StyledListWrapper>
  )
}

export default TransactionList
